// extracted by mini-css-extract-plugin
export default {"search":"Search_search__FLhP+","queryInput":"Search_queryInput__XSmOv","searchButton":"Search_searchButton__8FA9j"};